import {USER_ROLE, RARING_PERMISSIONS} from '../../user-profile/constants';
import {FeedbacksData, TemporaryFeedbackOutput} from '../typedef';
import {inputValidation} from 'feedback-system/utils';
import {getConcatCommentText} from 'feedback-system/utils/getConcatCommentText';

const checkForUser = (authUserRoles: string[], primaryPosition: string = USER_ROLE.USER) => {
    const authPermissions = [...new Set(authUserRoles.reduce(
        (rolesAcc: string[], value: string) =>
            (RARING_PERMISSIONS[value].length ? [...rolesAcc, ...RARING_PERMISSIONS[value]] : rolesAcc), [])
    )];
    return authPermissions.includes(primaryPosition);
};

const shouldLoadTeam = (roles: string[]) => {
    const shouldLoadTeamRoles = [USER_ROLE.TL, USER_ROLE.ASSOCIATED_TL, USER_ROLE.MANAGER];
    return roles.some(role => shouldLoadTeamRoles.includes(role));
};

const submitFeedback = (feedbacks: FeedbacksData[], submitedFeedback: number[]) => {
    return feedbacks.map((item: FeedbacksData) => {
        const isIncludeId =
            item.feedbacks && item.feedbacks[0] && submitedFeedback.includes(item.feedbacks[0].feedbackId);
        return item.feedbacks && isIncludeId ? {
            ...item,
            feedbacks: [
                {
                    ...item.feedbacks[0],
                    feedbackData: {
                        ...item.feedbacks[0].feedbackData,
                        STATUS: 'SUBMITTED'
                    }
                },
                ...item.feedbacks
            ]
        } : item;
    });
};

const validateMyTeamFeedbacks = (feedbacks: TemporaryFeedbackOutput[]) => {
    if (feedbacks.some(feedback => !feedback.id)) {
        return false;
    }
    const validFeedbacks = feedbacks.filter(feedback => {
        const formatText = feedback.comment ? getConcatCommentText(feedback.comment) : null;
        return !!(feedback.userRating !== null && inputValidation(feedback.userRating) && formatText);
    });
    return !!(feedbacks.length && feedbacks.length === validFeedbacks.length);
};

const getValidOptionalFeedbacks = (feedbacks: TemporaryFeedbackOutput[]) =>
    feedbacks.filter(feedback => {
        const formatText = feedback.comment ? getConcatCommentText(feedback.comment) : null;
        return !!formatText;
    });

const validateOptionalFeedbacks = (feedbacks: TemporaryFeedbackOutput[]) => {
    if (feedbacks.some(feedback => !feedback.id)) {
        return false;
    }
    const validFeedbacks = getValidOptionalFeedbacks(feedbacks);
    return !!(feedbacks.length && feedbacks.length === validFeedbacks.length);
};

export {
    checkForUser,
    shouldLoadTeam,
    submitFeedback,
    validateMyTeamFeedbacks,
    getValidOptionalFeedbacks,
    validateOptionalFeedbacks
};
